const modal = "_ibqmy3kkma";
const copyLinkThrobber = "_ibqc2otpji";
const heading = "_ibqhv7yt9k";
const input = "_ibqi1m6wluj";
const legalText = "_ibql16wps0m";
const shareText = "_ibqswu49qp";
const text = "_ibqtr3wtod";
const buttonsWrapper = "_ibqb1dn7s2l";

export { buttonsWrapper, copyLinkThrobber, heading, input, legalText, modal, shareText, text };
import "./_shared.style.linaria.module.css";
//# sourceMappingURL=_shared.style.js.map
